import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';


import { AppComponent } from './app.component';
import {ChartComponent} from "./chart/chart.component";
import {ChartService} from "./service/chart.sevice";
import {HttpRequestor} from "./common/HttpRequestor";
import {WebSocketService} from "./service/web-socket.service";

@NgModule({
  declarations: [
    AppComponent,
    ChartComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule
  ],
  providers: [ChartService, HttpRequestor, WebSocketService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts